export var reduxKey = '@@coreBadge';
//# sourceMappingURL=constants.js.map